import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import {MatBadgeModule} from "@angular/material/badge";
import {MatIconModule} from "@angular/material/icon";

import {DocumentBookmarksButtonComponent} from "./components/document-bookmarks-button/document-bookmarks-button.component";
import {MatButtonModule} from "@angular/material/button";

export {BookmarkService} from "./bookmark.service";

@NgModule({
  declarations: [
    DocumentBookmarksButtonComponent
  ],
  exports:[
    DocumentBookmarksButtonComponent,
  ],
    imports: [
        CommonModule,
        MatBadgeModule,
        MatIconModule,
        MatButtonModule
    ]
})
export class BookmarksModule { }
